import {Injectable} from '@angular/core'
import {ErrorsProps, logErrorToBackand, toErrorsPage} from './errors.actions'
import {EffectUtil, SimpleRedirectEffectType} from '../effect-util'
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {mergeMap, tap} from 'rxjs/operators';
import {of, zip} from 'rxjs';
import {correlationIdSelector} from '../samoobsluga/samoobsluga.selectors';
import {selectInfo} from '../info/info.selectors';
import {Store} from '@ngrx/store';
import {LoggingService} from '../../services/logging/logging.service';

@Injectable()
export class ErrorsEffect {

  constructor(
    private effectUtil: EffectUtil,
    private actions$: Actions,
    private store: Store,
    private loggingService: LoggingService
  ) {}

  errorEffect$: SimpleRedirectEffectType<ErrorsProps> = this.effectUtil.createRedirectEffect(toErrorsPage, 'error')

  logErrorToBackand$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(logErrorToBackand),
        mergeMap((action) => {
          return zip(of(action), this.store.select(correlationIdSelector), this.store.select(selectInfo))
        }),
        tap(([action, correlationId, info]) => {
          this.loggingService.log({
            correlationId: correlationId,
            appInfo: info,
            error: {
              name: action.error.name,
              message: action.error.message,
              stack: action.error.stack
            }
          }).subscribe()
        })
      );
    }, {dispatch: false}
  );
}
